const clientId = import.meta.env.VITE_CLIENT_ID;
const tenantId = import.meta.env.VITE_TENANT_ID;
const redirectUri = import.meta.env.VITE_REDIRECT_URI;
const redirectUriLogout = import.meta.env.VITE_REDIRECT_URI_LOGOUT;

export const msalConfig = {
    auth: {
        clientId: clientId,
        authority: `https://login.microsoftonline.com/${tenantId}/v2.0`,
        redirectUri: redirectUri,
        navigateToLoginRequestUrl: false,
        postLogoutRedirectUri: redirectUriLogout,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: [`api://${clientId}/access_as_user`],
};